<template>
	<div>
		<div class="row">
			<div class="col-xs-12">
				<div class="row">
					<input-model-data-hora
						class="col-xs-12 col-md-4 form-group"
						:label="_traducao('global', 'dataDaOcorrencia')"
						v-model="form.data"
						:disabled="!isCadastro"
					/>

					<input-model-text
						class="col-xs-12 col-md-4 form-group"
						:label="_traducao('global', 'local')"
						v-model="form.local"
						:disabled="!isCadastro"
					/>

					<input-model-select
						class="col-xs-12 col-md-4 form-group"
						:label="`${_traducao('global', 'aeronave')} (${_traducao('global', 'se').toLowerCase()} ${_traducao(
							'global',
							'aplicavel'
						).toLowerCase()})`"
						:opcoes-objeto="aeronaves"
						v-model="form.id_aeronave"
						label-option="descricao"
						campo-valor="id"
						:carregando="carregando.aeronaves"
						:disabled="!isCadastro"
					/>
				</div>

				<div class="row">
					<input-model-select
						class="col-xs-12 col-md-3 form-group"
						:label="_traducao('global', 'estado')"
						:opcoes-objeto="estados"
						v-model="form.id_estado"
						label-option="nome"
						campo-valor="id"
						:carregando="carregando.estados"
						:disabled="!isCadastro"
					/>

					<input-model-select
						class="col-xs-12 col-md-3 form-group"
						:label="_traducao('menuAGnovoUsuario', 'menuAGcidade')"
						:opcoes-objeto="cidades"
						v-model="form.id_cidade"
						label-option="descricao"
						campo-valor="id"
						:carregando="carregando.cidades"
						:disabled="!isCadastro || !cidades.length"
					/>

					<input-model-select
						class="col-xs-12 col-md-3 form-group"
						:label="_traducao('global', 'objeto')"
						:opcoes-objeto="objetos"
						v-model="form.tipo_evento"
						label-option="descricao"
						campo-valor="id"
						:carregando="carregando.objetos"
						:disabled="permissaoEditarObjeto"
					/>

					<input-model-select
						class="col-xs-12 col-md-3 form-group"
						:label="_traducao('global', 'fatorContribuinte')"
						:opcoes-objeto="fatoresContribuintes"
						v-model="form.id_evento"
						label-option="descricao"
						campo-valor="id"
						:mensagem-informacao="
							form.tipo_evento.model && !fatoresContribuintes.length
								? _traducao('global', 'naoExisteFatoresContribuintesParaOObjetoEscolhido')
								: ''
						"
						:carregando="carregando.fatoresContribuintes"
						:disabled="permissoesFatoresContribuintes"
					/>
				</div>

				<div class="row">
					<input-model-textarea
						class="col-xs-12 form-group"
						v-model="form.envolvidos"
						:label="_traducao('global', 'pessoalEnvolvido')"
						:disabled="!isCadastro"
					/>
				</div>

				<div class="row">
					<input-model-textarea
						class="col-xs-12 form-group"
						v-model="form.descricao"
						:label="_traducao('global', 'descricao')"
						:disabled="!isCadastro"
					/>
				</div>

				<div class="row">
					<input-model-text
						class="col-xs-12 col-md-4 form-group"
						:label="_traducao('global', 'relator')"
						v-model="form.relator"
						:disabled="!isCadastro"
					/>

					<input-model-text-mask
						class="col-xs-12 col-md-4 form-group"
						:label="_traducao('global', 'telefone')"
						v-model="form.telefone"
						telefone-mask
						:disabled="!isCadastro"
					/>

					<input-model-text
						class="col-xs-12 col-md-4 form-group"
						:label="_traducao('global', 'email')"
						v-model="form.email"
						:disabled="!isCadastro"
					/>
				</div>
			</div>
		</div>

		<!-- Anexar arquivo -->
		<div class="col-sm-12" :key="atualizaAnexos">
			<div class="row">
				<flCabecalhoForm class="print-titulo-form-20" :texto="_traducao('global', 'anexos')" />
			</div>
			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 form-group">
				<label>{{ _traducao('global', 'arquivo') }}</label>
				<div class="d-flex">
					<flUploadFile
						ref="anexos"
						id-input="layer"
						:excluirURL="true"
						:unico="false"
						@upload-file="(files) => uploadFiles(files)"
						@enviando="loadArquivo(true)"
						@enviado="loadArquivo(false)"
						:url="urlEnvio"
						:exibeListaCarregados="false"
						ext="kml|jpg|jpeg|png|pdf|doc|docx|xls|xlsx"
					>
					</flUploadFile>
				</div>
			</div>

			<div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 pull-right" v-if="anexoAdd.length > 0">
				<label
					>{{ _traducao('global', 'lista').capitalizeFirst() }} {{ _traducao('global', 'de').toLowerCase() }}
					{{ _traducao('global', 'anexos') }}
				</label>
				<ul style="list-style-type: none; padding-left: 2%">
					<li v-for="(anexo, idxAnexo) of anexoAdd" :key="anexo.caminho">
						<a> {{ anexo.nome }} </a>
						<a><i class="fa fa-trash-o" style="color: #e00; float: right" @click="anexoAdd.splice(idxAnexo, 1)"> </i> </a>
					</li>
				</ul>
			</div>
		</div>

		<div class="row button-margin">
			<div class="col-xs-12">
				<span class="label label-info pull-left no-print">
					<i class="fa fa-info-circle"></i> {{ _traducao('global', 'obrigatorio') }}
				</span>

				<button type="button" @click="clickSalva" class="btn btn-success pull-right">
					<i class="fa fa-check" aria-hidden="true"></i> {{ _traducao('global', 'salvar').toUpperCase() }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import RelatorioPrevencao from '@/models/RelatorioPrevencao.js'

export default {
	name: 'RelatorioPrevencaoFormCadastro',

	props: {
		isLogin: {
			type: Boolean,
			required: false,
			default: false
		},

		usarModalSucesso: {
			type: Boolean,
			required: false,
			default: false
		},

		isCadastro: {
			type: Boolean,
			required: false,
			default: true
		},

		idRelPrev: {
			type: [String, Number],
			default: 0
		}
	},

	data() {
		const relatorioPrevencao = new RelatorioPrevencao()
		return {
			atualizaAnexos: 0,
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			anexoAdd: [],

			relatorioPrevencao,
			form: relatorioPrevencao.atributos,
			cidades: [],
			estados: [],
			aeronaves: [],
			/*
				O array de fatoresContribuintes seria os eventos e o de objetos seria os tipos do evento.
				O motivo dessa alteração foi uma solicitação do Guilherme da PF.
			*/
			objetos: [],
			fatoresContribuintes: [],
			carregando: {
				estados: false,
				cidades: false,
				aeronaves: false,
				objetos: false,
				fatoresContribuintes: false
			}
		}
	},

	mounted() {
		this.carregaEstados()
		this.carregaObjetos()
		this.carregaAeronaves()

		if (!this.isCadastro) {
			this.relatorioPrevencao.get(this.idRelPrev)
		} else {
			this.buscarEstadoCliente()
			this.carregaDadosUsuario()
		}
	},

	watch: {
		'form.id_estado.model': function (idEstadoAtual) {
			this.carregaCidades(idEstadoAtual)
		},

		'form.tipo_evento.model': function (idObjetoAtual) {
			if (idObjetoAtual) {
				this.carregaFatoresContribuintes(idObjetoAtual)
			} else {
				this.fatoresContribuintes = []
				this.form.id_evento.model = ''
			}
		}
	},

	methods: {
		uploadFiles(files) {
			this.anexoAdd.push({
				id: 0,
				nome: files.length > 0 ? files[files.length - 1].nome : files[0].nome,
				caminho: files.length > 0 ? files[files.length - 1].nomeTemp : files[0].nomeTemp,
				id_relatorio_prevencao: this.form.id.model
			})
		},

		loadArquivo(inicio) {
			if (inicio) {
				window.bus.$emit('load-in', {text: this._traducao('global', 'enviando')})
			} else {
				window.bus.$emit('load-out')
			}
		},

		buscarEstadoCliente() {
			this.form.id_estado.model = window.$cliente.get('id_estado')
			this.carregaCidades(window.$cliente.get('id_estado'))
		},

		carregaAeronaves() {
			this.carregando.aeronaves = true

			this._httpGet('/Aeronave/get_aeronave', (retorno) => {
				this.carregando.aeronaves = false

				if (retorno._request && retorno._status) {
					this.aeronaves = retorno.lista.map(({id, codinome, prefixo}) => ({
						id,
						descricao: `${codinome} - ${prefixo}`
					}))
				}
			})
		},

		carregaEstados() {
			this.carregando.estados = true

			this._providerEstado((estados) => {
				this.carregando.estados = false
				this.estados = estados
			})
		},

		carregaCidades(idEstado) {
			this.carregando.cidades = true

			if (idEstado) {
				this._httpGet(`/Cidade/get_cidade_by_id_estado/${idEstado}`, (retorno) => {
					this.carregando.cidades = false

					if (retorno._request && retorno._status) {
						if (!this.verificarSeIdExisteNaLista(retorno.lista, this.form.id_cidade.model)) {
							this.form.id_cidade.model = ''
						}

						this.cidades = retorno.lista
					}
				})
			} else {
				this.cidades = []
			}
		},

		carregaObjetos() {
			this.carregando.objetos = true
			this._httpGet('Evento/get_tipo_evento_by_modulo/relatorio_prevencao', (retorno) => {
				this.carregando.objetos = false

				if (retorno._request && retorno._status) {
					this.objetos = retorno.lista
				}
			})
		},

		verificarSeIdExisteNaLista(lista, id) {
			return lista.find((item) => item.id == id)
		},

		carregaFatoresContribuintes(idObjetoAtual) {
			this.carregando.fatoresContribuintes = true

			this._httpGet(`Evento/get_by_tipo/${idObjetoAtual}`, (retorno) => {
				this.carregando.fatoresContribuintes = false

				if (retorno._request && retorno._status) {
					if (!this.verificarSeIdExisteNaLista(retorno.lista, this.form.id_evento.model)) {
						this.form.id_evento.model = ''
					}

					this.fatoresContribuintes = retorno.lista
				}
			})
		},

		salvar() {
			this.relatorioPrevencao.salvar((retorno) => {
				if (retorno._request) {
					window.bus.$emit('load-out')
					this.relatorioPrevencao.preencheAtributos({id: retorno.relatorio_prevencao[0].id})

					if (this.usarModalSucesso) this.$emit('alterar-status-modal-sucesso')

					this.anexoAdd = this.anexoAdd.map((elem) => {
						elem.id_relatorio_prevencao = retorno.relatorio_prevencao[0].id
						return elem
					})

					this._axios('Relatorio_prevencao_anexo/salvar', 'post', {
						data: this.anexoAdd,
						callback: (res) => {
							if (res._request) {
								window.bus.$emit('exibir-notificacao', {
									type: 'success',
									text: this._traducao('global', 'salvoComSucesso')
								})
							} else {
								window.bus.$emit('exibir-notificacao', {type: 'danger', text: retorno.mensagem})
							}
						}
					})

					if (this.isLogin) this.$emit('imprimir-rel-prev', retorno.relatorio_prevencao[0])
					else this.$emit('alterar-id-relatorio', this.form.id.model)
				}
			})
		},

		atualizar() {
			this.relatorioPrevencao.atualizar((retorno) => {
				if (retorno._request) {
					window.bus.$emit('load-out')
					this.relatorioPrevencao.preencheAtributos({id: retorno.lista[0].id})

					if (this.usarModalSucesso) this.$emit('alterar-status-modal-sucesso')

					if (this.isLogin) this.$emit('imprimir-rel-prev', retorno.lista[0])
					else this.$emit('alterar-id-relatorio', this.form.id.model)
				}
			})
		},

		clickSalva() {
			if (this.isCadastro) {
				this.salvar()
			} else {
				this.atualizar()
			}
		},

		carregaDadosUsuario() {
			if (this._idUsuario) {
				this._axios('Usuario/editar/' + window.$sessao.getId(), 'get', {
					callback: (resposta) => {
						this.form.relator.model = resposta.usuario.nome
						this.form.telefone.model = resposta.usuario.celular
						this.form.email.model = resposta.usuario.email
					}
				})
			}
		}
	},

	computed: {
		permissoesFatoresContribuintes() {
			if (this.form.id.model != 0) {
				return this._getPrivilegio(274) && this.fatoresContribuintes.length > 0 ? false : true
			} else {
				return this.fatoresContribuintes.length > 0 ? false : true
			}
		},

		permissaoEditarObjeto() {
			if (this.form.id.model != 0) {
				return !this._getPrivilegio(274)
			} else {
				return false
			}
		}
	}
}
</script>